import React from "react";
import { Col, Row, Container } from "reactstrap";
import t from "utils/Lang";
import "./index.css";

// The Roster component matches one of two different routes
// depending on the full pathname

const Settings = () => {
  return (
    <Container>
      <Row>
        <Col xs={12}>
          <h1>{t().settings__title}</h1>
        </Col>
      </Row>
    </Container>
  );
};

export default Settings;
